// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDw6-XMvgGbVRYazYskqGU4INNOqlODCMY",
  authDomain: "orders-8dae5.firebaseapp.com",
  projectId: "orders-8dae5",
  storageBucket: "orders-8dae5.appspot.com",
  messagingSenderId: "326085091774",
  appId: "1:326085091774:web:99e01581176bdfd27459ef"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);